import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import {
  Box,
  Drawer,
  Paper,
  useMediaQuery,
} from '@mui/material';

import { useSession } from 'store';
import { Navigation } from 'components';
import navCfg from './cfg';

const NavBar = ({openDrawer, onDrawerClose, brief, hide, styles, ...rest}) => {
  const session = useSession((state) => state.session);
  const loc = useLocation();
  const lgUp = useMediaQuery(theme => theme.breakpoints.up('lg'));

  const isAdmin = session.role === 'admin';
  const items = navCfg.filter(item => isAdmin || !item.needAdmin);

  // close nav bar if url changed
  useEffect(
    () => void(openDrawer && onDrawerClose?.()),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [loc.pathname]
  );

  const navbarContent = (
    <Box sx={{
      padding: 2,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      minHeight: 'fit-content'
    }}>
      <Navigation items={items} brief={brief} />
    </Box>
  );

  // only use drawer on mobile for 'auto' hide
  const useDrawer = ({always: true, never: false, auto: !lgUp})[hide];

  return !useDrawer ? (
    <Paper
      {...rest}
      sx={{height: '100%', overflowY: 'auto', ...styles}}
      elevation={1}
      square
    >
      {navbarContent}
    </Paper>
  ) : (
    <Drawer
      anchor="left"
      onClose={onDrawerClose}
      open={openDrawer}
      variant="temporary"
    >
      <Box
        {...rest}
        sx={{height: '100%', overflowY: 'auto', ...styles}}
      >
        {navbarContent}
      </Box>
    </Drawer>
  );
};

NavBar.propTypes = {
  styles: PropTypes.object,
  onDrawerClose: PropTypes.func,
  openDrawer: PropTypes.bool,
  brief: PropTypes.bool,
  hide: PropTypes.oneOf(['always', 'never', 'auto']),
};

export default NavBar;
